export const SALEORDER_STATUS_DRAFT = "DRAFT";
export const SALEORDER_STATUS_PRODUCT_RESERVED = "PRODUCT_RESERVED";
export const SALEORDER_STATUS_CONFIRMED = "CONFIRMED";
export const SALEORDER_STATUS_SIGNED_CONTRACT = "SIGNED_CONTRACT";



// WEBPACK FOOTER //
// ./src/constants/saleOrderStatusConst.js